<template>
  <div>
    <div>
      <pre>
        NFPA 10 Standard for Portable Fire Extinguishers 2007 Edition 

        Chapter 7 Inspection, Maintenance, and Recharging of Portable Fire Extinguishers 
        7.1* General. 
        7.1.1 Responsibility. The owner or designated agent or occupant of a property in which fire extinguishers are located shall be responsible for 
        inspection, maintenance, and recharging. (See 7.1.2.) 

        7.1.2 Personnel. 
        7.1.2.1 A trained and certified person who has undergone the instructions necessary to reliably perform maintenance and has the manufacturer's 
        service manual shall service the fire extinguishers not more than 1 year apart, as outlined in Section 7.3. 
        7.1.2.2* Maintenance, servicing, and recharging shall be performed by trained and certified persons having available the appropriate  
        servicing manual(s), the proper types of tools, recharge materials, lubricants, and manufacturer's recommended replacement parts 
        or parts specifically listed for use in the fire extinguisher.
        7.1.2.3 The certification of service personnel shall be required after August 17, 2008. 

        7.1.3 Replacement While Servicing. Fire extinguishers removed from service for maintenance or recharging shall be replaced by 
        a fire extinguisher suitable for the type of hazard being protected and shall be of at least equal rating. 

        7.1.4 Tags or Labels. 
        7.1.4.1 Tags or labels intended for recording inspections, maintenance, or recharging shall not be placed on the front of the fire extinguishers. 
        7.1.4.2 Labels indicating fire extinguisher use or classification or both shall be permitted to be placed on the front of the fire extinguisher. 

        7.2 Inspection. 
        7.2.1 Frequency. 
        7.2.1.1* Fire extinguishers shall be manually inspected when initially placed in service. 
        7.2.1.2 Fire extinguishers shall be inspected either manually or by means of an electronic monitoring device/system 
        at a minimum of 30-day intervals. 
        7.2.1.2.1 Where electronic monitoring is used and the specific extinguisher cannot be verified electronically, 
        the extinguisher shall be continuously monitored for location. 

        7.2.1.3* Fire extinguishers shall be inspected at more frequent intervals when circumstances require. 
        7.2.2* Procedures. Periodic inspection or electronic monitoring of fire extinguishers shall include a check of at least the following items: 
        (1)      Location in designated place 
        (2)      No obstruction to access or visibility 
        (3)      Pressure gauge reading or indicator in the operable range or position 
        (4)      Fullness determined by weighing or hefting for self-expelling-type extinguishers, cartridge-operated extinguishers, and pump tanks 
        (5)      Condition of tires, wheels, carriage, hose, and nozzle for wheeled extinguishers 
        (6)      Indicator for nonrechargeable extinguishers using push-to-test pressure indicators 

        7.2.2.1 In addition to 7.2.2, fire extinguishers shall be visually inspected in accordance with 7.2.2.2 
        if they are located where any of the following conditions exist: 
        (1)      High frequency of fires in the past 
        (2)      Severe hazards 
        (3)      Locations that make fire extinguishers susceptible to mechanical injury or physical damage 
        (4)      Exposure to abnormal temperatures or corrosive atmospheres 

        7.2.2.2 Where required by 7.2.2.1, the following inspection procedures shall be in addition to those addressed in 7.2.2: 
        (1)      Operating instructions on nameplates are legible and face outward 
        (2)      Safety seals and tamper indicators are broken or missing 
        (3)      Examination for obvious physical damage, corrosion, leakage, or clogged nozzle 

        7.2.3 Corrective Action. When an inspection of any fire extinguisher reveals a deficiency in any of the conditions listed in 7.2.2, 
        immediate corrective action shall be taken. 

        7.2.3.1 Rechargeable Fire Extinguishers. When an inspection of any rechargeable fire extinguisher reveals a deficiency in any of the conditions 
        listed in 7.2.2(3) or 7.2.2(4), it shall be subjected to applicable maintenance procedures. 

        7.2.3.2 Nonrechargeable Dry Chemical Fire Extinguisher. When an inspection of any nonrechargeable dry chemical fire extinguisher reveals 
        a deficiency in any of the conditions listed in 7.2.2(3), 7.2.2(4), or 7.2.2(6), it shall be removed from further use, discharged, 
        and destroyed at the direction of the owner or returned to the manufacturer. 

        7.2.3.3 Nonrechargeable Halon Agent Fire Extinguisher. When an inspection of any nonrechargeable fire extinguisher containing 
        a halon agent reveals a deficiency in any of the conditions listed in 7.2.2(3), 7.2.2(4), or 7.2.2(6), it shall be removed from service, 
        not discharged, and returned to the manufacturer, a fire equipment dealer, or a distributor to permit recovery of the halon. 

        7.2.4 Inspection Record Keeping. 
        7.2.4.1 Personnel making manual inspections shall keep records of all fire extinguishers inspected,
        including those found to require corrective action. 
        7.2.4.2 Where electronic monitored systems are employed for inspections, records shall be kept for fire extinguishers 
        found to require corrective action. 
        7.2.4.3 At least monthly where manual inspections are conducted, the date the manual inspection was performed and the initials of the person 
        performing the inspection shall be recorded. 
        7.2.4.4 Where manual inspections are conducted, records for manual inspections shall be kept on a tag or label attached to the fire extinguisher, 
        on an inspection checklist maintained on file, or by an electronic method. 
        7.2.4.5 Records shall be kept to demonstrate at least the last 12 monthly inspections have been performed. 
        7.2.4.6 Fire extinguishers inspected via electronic monitoring, whereby the extinguisher causes a signal at a control unit when a deficiency in 
        any of the conditions listed in 7.2.2 occurs, shall provide record keeping in the form of an electronic event log at the control panel. 

        7.3* Maintenance. 
        7.3.1 Frequency. 
        7.3.1.1 All Fire Extinguishers. 
        7.3.1.1.1 Fire extinguishers shall be subjected to maintenance at intervals of not more than 1 year, at the time of hydrostatic test, 
        or when specifically indicated by an inspection or electronic notification. 
        7.3.1.1.2 Fire extinguishers shall be internally examined at intervals not exceeding those specified in Table 7.3.1.1.2. </pre
      >
    </div>
    <div>
      <b-table fixed striped hover :items="items">
        <template #table-caption
          >*Dry chemical and dry powder in cartridge- or cylinder-operated
          extinguishers are examined annually. <br />†The extinguishing agent in
          liquid charge-type AFFF and FFFP extinguishers is replaced every 3
          years, and an internal examination (teardown) is normally conducted at
          that time.</template
        >
      </b-table>
    </div>
    <div>
      <pre>
        7.3.1.2 Stored-Pressure Types. 
        7.3.1.2.1* Six-Year Maintenance. Every 6 years, stored-pressure fire extinguishers that require a 12-year hydrostatic test shall be emptied 
        and subjected to the applicable maintenance procedures as detailed in the manufacturer's service manual. 
        7.3.1.2.1.1 When the applicable maintenance procedures are performed during periodic recharging or hydrostatic testing, 
        the 6-year requirement shall begin from that date. 
        7.3.1.2.1.2 The removal of agent from halon agent fire extinguishers shall only be done using a listed halon closed recovery system. 
        7.3.1.2.1.3 Nonrechargeable fire extinguishers shall not be required to comply with 7.3.1.2.1.2 and shall not be hydrostatically tested but 
        shall be removed from service at a maximum interval of 12 years from the date of manufacture. 
        7.3.1.2.1.4 Nonrechargeable halon agent fire extinguishers shall be disposed of in accordance with 7.2.3.3. 

        7.3.1.2.2 Loaded Stream Charge. Stored-pressure types of fire extinguishers containing a loaded stream agent shall be disassembled 
        on an annual basis and subjected to complete maintenance. 
        7.3.1.2.3 When subjected to temperatures at or above its listed rating, stored-pressure fire extinguishers that require a 12-year hydrostatic test 
        shall be emptied and subjected to the applicable maintenance and recharge procedures on an annual basis. 
        7.3.1.2.4 When the applicable maintenance procedures are performed during periodic recharging or hydrostatic testing, 
        the 1-year requirement shall begin from that date. 
        7.3.1.3* Carbon Dioxide Hose Assemblies. A conductivity test shall be conducted annually on all carbon dioxide hose assemblies. 
        7.3.1.3.1 Carbon dioxide hose assemblies that fail the conductivity test shall be replaced. 
        7.3.1.3.2 Carbon dioxide hose assemblies that pass a conductivity test shall have the test information recorded on a suitable metallic label or 
        equally durable material that has a minimum size of 1/2 in.x 3 in.(13 mm x 76 mm)

        7.3.1.3.2.1 The label shall be affixed to the hose by means of a heatless process. 
        7.3.1.3.2.2 The label shall include the following information: 
        (1)      Month and year the test was performed, indicated by perforation, such as is done by a hand punch 
        (2)      Name or initials of person performing the test and the name of the agency performing the test 

        7.3.1.4 Pressure Regulators. Pressure regulators provided with wheeled-type fire extinguishers shall be tested annually for outlet static pressure 
        and flow rate in accordance with manufacturer's instructions. 
        7.3.2* Procedures. Maintenance procedures shall include a thorough examination of the basic elements of a fire extinguisher and components of 
        the electronic monitoring system and following the procedures detailed in the manufacturer's service manual: 
        (1)      Mechanical parts of all fire extinguishers 
        (2)      Extinguishing agent of cartridge- or cylinder-operated dry chemical, stored-pressure loaded stream, and pump tank fire extinguishers 
        (3)      Expelling means of all fire extinguishers 
        (4)      Physical appearance 
        (5)*      Components of electronically monitored system 

        7.3.2.1 Internal and External Examination. 
        7.3.2.1.1 Internal examination during annual maintenance shall not be required for nonrechargeable fire extinguishers, 
        carbon dioxide fire extinguishers, or stored-pressure fire extinguishers, except for those types specified in 7.3.1.2.2. 
        7.3.2.1.2 These fire extinguishers shall be thoroughly examined externally in accordance with the applicable items of 7.3.2(1). 

        7.3.2.2* Seals or Tamper Indicators. At the time of the maintenance, the tamper seal of a rechargeable fire extinguisher shall be removed 
        by operating the pull pin or locking device. 
        7.3.2.2.1 After the applicable maintenance procedures are completed, a new listed tamper seal shall be installed. 
        7.3.2.2.2 Tamper indicators on nonrechargeable-type extinguishers shall not be removed. 
        7.3.2.3* Boots, Foot Rings, and Attachments. All removable extinguisher boots, foot rings, and attachments shall be removed 
        to accommodate thorough annual cylinder examinations. 

        7.3.2.4 Physical Appearance. A visual examination of the extinguisher shall be made to examine for obvious physical damage, corrosion, 
        or nozzle blockage, and to verify the operating instructions are present, legible, and facing forward and the HMIS information is present and legible. 

        7.3.2.5 Electronic Monitoring. The components of the monitoring device/system shall be tested and maintained annually in accordance with 
        the manufacturer's listed maintenance manual with the following items as a minimum: 
        (1)      Power supply inspection/battery change 
        (2)      Obstruction sensor inspection 
        (3)      Location sensor inspection 
        (4)      Pressure indication inspection 
        (5)      Connection continuity inspection (see 7.3.2.5.1 and 7.3.2.5.2) 
        7.3.2.5.1 One hundred percent of all units shall be tested upon initial installation or reacceptance with verification of receipt of signal 
        at the control panel or a local alarm.  
        7.3.2.5.2 Twenty percent of units shall be tested annually on a rotating basis so that all units are tested within a 5-year period.  
        7.3.3* Maintenance Record Keeping. Each fire extinguisher shall have a tag or label securely attached that indicates the month and year 
        the maintenance was performed, identifies the person performing the work, and identifies the name of the agency performing the work. 

        7.3.3.1* Six-Year Service Label. Fire extinguishers that pass the applicable 6-year requirement of 7.3.1.2.1 shall have the maintenance 
        information recorded on a suitable metallic label or equally durable material that is a minimum size of 2 in.x 3-1/2 in. (51 mm x 89 mm).

        7.3.3.1.1 The new label shall be affixed to the shell by a heatless process, and any old maintenance labels shall be removed. 
        7.3.3.1.2 These labels shall be of the self-destructive type when removal from a fire extinguisher is attempted. 
        7.3.3.1.3 The label shall include the following information: 
        (1)      Month and year the maintenance was performed, indicated by a perforation such as is done by a hand punch 
        (2)      Name or initials of the person performing the maintenance and name of the agency performing the maintenance 

        7.3.3.2* Verification of Service Collar (Maintenance or Recharging). 
        7.3.3.2.1 Each extinguisher that has undergone maintenance that includes internal examination or that has been recharged (see 7.4.5.2) 
        shall have a verification of service collar located around the neck of the container. 
        7.3.3.2.1.1 The collar shall contain a single circular piece of uninterrupted material forming a hole of a size that does not permit the collar 
        assembly to move over the neck of the container unless the valve is completely removed. 
        7.3.3.2.1.2 The collar shall not interfere with the operation of the fire extinguisher. 
        7.3.3.2.1.3 The collar shall include the month and year the service was performed, indicated by a perforation such as is done by a hand punch. 
        7.3.3.2.2 Cartridge- or cylinder-operated fire extinguishers shall not be required to comply with 7.3.3.2.1. 
        7.3.3.2.3 New extinguishers requiring an initial charge in the field (such as pressurized water extinguishers, AFFF, FFFP, or wet chemical) 
        shall not be required to have a verification of service collar installed. 

        7.4 Recharging. 
        7.4.1* General. 
        7.4.1.1 All rechargeable-type fire extinguishers shall be recharged after any use or as indicated by an inspection or when performing maintenance. 
        7.4.1.2* When performing the recharging, the recommendations of the manufacturer shall be followed. (For recharge chemicals, see 7.4.3.1.) 
        7.4.1.3* The amount of recharge agent shall be verified by weighing. 
        7.4.1.3.1 The recharged gross weight shall be the same as the gross weight that is marked on the nameplate. 
        7.4.1.3.2 For those fire extinguishers that do not have the gross weight marked on the nameplate or valve, 
        a permanent label that indicates the gross weight shall be affixed to the cylinder. 
        7.4.1.3.3 The added label containing the gross weight shall be a durable material of a pressure-sensitive, self-destruct type. 
        (For stored-pressure water-type extinguishers, see 7.4.3.10.) 
        7.4.1.3.4 Pump tank water and pump tank calcium chloride–based antifreeze types shall not be required to have weight marked. 
        7.4.1.3.5* After recharging, a leak test shall be performed on stored-pressure and self-expelling types of fire extinguishers. 

        7.4.1.4 Conversion of Fire Extinguisher Types. 
        7.4.1.4.1 No fire extinguisher shall be converted from one type to another, nor shall any fire extinguisher be converted to use 
        a different type of extinguishing agent. 
        7.4.1.4.2 Fire extinguishers shall not be used for any other purpose than that of a fire extinguisher. 

        7.4.2 Frequency. 
        7.4.2.1 Pump Tank. Every 12 months, pump tank water and pump tank calcium chloride–based antifreeze types of fire extinguishers 
        shall be recharged with new chemicals or water as applicable. 

        7.4.2.2 Wetting Agent. The agent in stored-pressure wetting agent fire extinguishers shall be replaced annually. 
        7.4.2.2.1 Only the agent specified on the nameplate shall be used for recharging. 
        7.4.2.2.2 The use of water or any other additives shall be prohibited. 

        7.4.2.3 AFFF and FFFP. 
        7.4.2.3.1 The premixed agent in liquid charge–type AFFF and FFFP fire extinguishers shall be replaced at least once every 3 years. 
        7.4.2.3.2 Only the foam agent specified on the extinguisher nameplate shall be used for recharge. 
        7.4.2.3.3 The agent in nonpressurized AFFF and FFFP fire extinguishers that is subjected to agent analysis 
        in accordance with manufacturer's instructions shall not be required to comply with 7.4.2.3.1. 

        7.4.3 Procedures. 
        7.4.3.1* Recharge Agents. 
        7.4.3.1.1 Only those agents specified on the nameplate or agents proven to have equal chemical composition, physical characteristics, 
        and fire-extinguishing capabilities shall be used. 
        7.4.3.1.2 Agents listed specifically for use with that fire extinguisher shall be considered to meet these requirements. 
        7.4.3.2* Mixing of Dry Chemicals. Multipurpose dry chemicals shall not be mixed with alkaline-based dry chemicals. 

        7.4.3.3 Topping Off. 
        7.4.3.3.1 The remaining dry chemical in a discharged fire extinguisher shall be permitted to be re-used, 
        provided that it is thoroughly checked for the proper type, contamination, and condition. 
        7.4.3.3.2 Dry chemical found to be of the wrong type, or contaminated, shall not be re-used. 

        7.4.3.4 Dry Chemical Agent Re-Use. 
        7.4.3.4.1 Fire extinguishers removed for 6-year maintenance or hydrostatic testing shall be emptied. 
        7.4.3.4.2 The dry chemical agent shall be permitted to be re-used, provided a closed recovery system is used and the agent is stored 
        in a sealed container to prevent contamination. 
        7.4.3.4.3 Prior to re-use, the dry chemical shall be thoroughly checked for the proper type, contamination, and condition. 
        7.4.3.4.4 Where doubt exists with respect to the type, contamination, or condition of the dry chemical, the dry chemical shall be discarded. 

        7.4.3.4.5 Dry Chemical Closed Recovery System. 
        7.4.3.4.5.1 The system shall be constructed in a manner that does not introduce foreign material into the agent being recovered. 
        7.4.3.4.5.2 The system shall have a means of visually inspecting the recovered agent for contaminants. 

        7.4.3.5 Dry Powder. 
        7.4.3.5.1 Pails or drums containing dry powder agents for scoop or shovel application for use on metal fires 
        shall be kept full and covered at all times. 
        7.4.3.5.2 The dry powder shall be replaced if found damp. (See A.7.4.3.1.) 
        7.4.3.6* Removal of Moisture. For all nonwater types of fire extinguishers, any moisture shall be removed before recharging. 
        7.4.3.7* Halogenated Agent. Halogenated agent fire extinguishers shall be charged only with the proper type 
        and weight of agent as specified on the nameplate. 

        7.4.3.8 Halogenated Agent Re-Use. 
        7.4.3.8.1 The removal of Halon 1211 from fire extinguishers shall be done only using a listed halon closed recovery system. 
        7.4.3.8.2 The removal of agent from other halogenated agent fire extinguishers shall be done only using a closed recovery system. 
        7.4.3.8.3 The fire extinguisher shall be examined internally for contamination or corrosion or both. 
        7.4.3.8.4 The halogenated agent retained in the system recovery cylinder shall be re-used only if no evidence of internal contamination is observed 
        in the fire extinguisher cylinder. 
        7.4.3.8.5 Halogenated agent removed from fire extinguishers that exhibits evidence of internal contamination or corrosion shall be processed 
        in accordance with the fire extinguisher manufacturer's instructions. 

        7.4.3.9* Carbon Dioxide. 
        7.4.3.9.1 The vapor phase of carbon dioxide shall be not less than 99.5 percent carbon dioxide. 
        7.4.3.9.2 The water content shall be not more than 60 parts per million (ppm) by weight at -52°F (-47°C) dew point. 
        7.4.3.9.3 Oil content shall not exceed 10 ppm by weight. 
        7.4.3.10* Water Types. The amount of liquid agent shall be determined by using one of the following: 
        (1)      Exact measurement by weight 
        (2)      Exact measurement in volume 
        (3)      Anti-overfill tube, if provided 
        (4)      Fill mark on fire extinguisher shell, if provided 

        7.4.3.10.1 Only the agent specified on the extinguisher nameplate shall be used for recharge. 

        7.4.3.11 Wet Chemical Agent Re-Use. 
        7.4.3.11.1 Wet chemical agents shall not be re-used. 
        7.4.3.11.2 If a wet chemical extinguisher is partially discharged, all remaining wet chemical shall be discarded. 
        7.4.3.11.3 Wet chemical agent shall be discarded and replaced at the hydrostatic test interval. 
        7.4.3.11.3.1 Only the agent specified on the extinguisher nameplate shall be used for recharge. 

        7.4.4 Precautionary Pressurization Measures. 
        7.4.4.1* Pressure Gauges. Replacement pressure gauges shall have the proper indicated charging (service) pressure, shall be marked 
        for use with the agent in the fire extinguisher, and shall be compatible with the fire extinguisher valve body material. 

        7.4.4.2 Stored-Pressure Fire Extinguishers. 
        7.4.4.2.1 A rechargeable stored-pressure-type fire extinguisher shall be pressurized only to the charging pressure specified  
        on the fire extinguisher nameplate.
        7.4.4.2.1.1 The manufacturer's pressurizing adapter shall be connected to the valve assembly before the fire extinguisher is pressurized. 
        7.4.4.2.1.2 A regulated source of pressure, set no higher than 25 psi (172 kPa) above the operating (service) pressure, 
        shall be used to pressurize fire extinguishers. 
        7.4.4.2.1.3 The gauge used to set the regulated source of pressure shall be calibrated at least annually. 
        7.4.4.2.2 An unregulated source of pressure, such as a nitrogen cylinder without a pressure regulator, shall never be used because 
        the fire extinguisher could be overpressurized and possibly rupture. 
        7.4.4.2.3* A fire extinguisher shall never be left connected to the regulator of a high-pressure source for an extended period of time. 

        7.4.4.3 Pressurizing Gas. Only standard industrial-grade nitrogen with a dew point of -60°F (-51°C) or lower 
        (CGA nitrogen specification G10.1, grades D through P) shall be used to pressurize stored-pressure dry chemical 
        and halogenated-type fire extinguishers. 
        7.4.4.3.1 Other halogenated-type fire extinguishers that require argon shall be pressurized with argon with a dew point of -65°F (-54°C) or lower. 
        7.4.4.3.2 Compressed air through moisture traps shall not be used for pressurizing even though so stated 
        in the instructions on older fire extinguishers. 
        7.4.4.3.3 Compressed air shall be permitted to be used from special compressor systems capable of delivering air 
        with a dew point of -60°F (-51°C) or lower. 
        7.4.4.3.4 The special compressor system shall be equipped with an automatic monitoring and alarm system to ensure that the dew point 
        remains at or below -60°F (-51°C) at all times. 
        7.4.4.3.5* Class D and halocarbon fire extinguishers shall be repressurized only with the type of 
        expellant gas referred to on the fire extinguisher label. 

        7.4.5 Recharge Record Keeping. 
        7.4.5.1 Each fire extinguisher shall have a tag or label attached that indicates the month and year recharging was performed, 
        identifies the person performing the service, and identifies the name of the agency performing the work. 
        7.4.5.2 A verification of service (maintenance or recharging) collar in accordance with 7.3.3.2 shall also be attached to the extinguisher. 
        7.4.5.2.1 Liquefied gas, halogenated agent, and carbon dioxide extinguishers that have been recharged without valve removal shall not be 
        required to have a verification of service collar installed following recharge. 
        7.4.5.2.2 Cartridge- and cylinder-operated extinguishers shall not be required to have a verification of service collar installed. (See 7.3.3.2.) 

        Chapter 8 Hydrostatic Testing

        8.3 Frequency. 
        8.3.1 General. At intervals not exceeding those specified in Table 8.3.1, fire extinguishers shall be hydrostatically retested. </pre
      >
    </div>
    <div>
      <b-table fixed striped hover :items="items2">
          <template>
          <b-tr>
            <!-- <b-th > </b-th> -->
            <b-th colspan="3">Table 8.3.1 Hydrostatic Test Interval for Extinguishers</b-th>
          </b-tr>
        </template>
      </b-table>
    </div>
    <div>
      <pre>
        8.3.1.1 The hydrostatic retest shall be conducted within the calendar year of the specified test interval. 
        8.3.1.2 In no case shall an extinguisher be recharged if it is beyond its specified retest date. 
        (For nonrechargeable fire extinguishers, see 7.3.1.2.1.3.) 

        4.4 Obsolete Fire Extinguishers. 
        The following types of fire extinguishers are considered obsolete and shall be removed from service: 
        (1)      Soda acid 
        (2)      Chemical foam (excluding film-forming agents) 
        (3)      Vaporizing liquid (e.g., carbon tetrachloride) 
        (4)      Cartridge-operated water 
        (5)      Cartridge-operated loaded stream 
        (6)      Copper or brass shell (excluding pump tanks) joined by soft solder or rivets 
        (7)      Carbon dioxide extinguishers with metal horns 
        (8)      Solid charge–type AFFF extinguishers (paper cartridge) 
        (9)      Pressurized water fire extinguishers manufactured prior to 1971 
        (10)      Any extinguisher that needs to be inverted to operate 
        (11)      Any stored pressure extinguisher manufactured prior to 1955 
        (12)      Any extinguishers with 4B, 6B, 8B, 12B, and 16B fire ratings 
        (13)      Stored-pressure water extinguishers with fiberglass shells (pre-1976) 
        4.4.1 Dry chemical stored pressure extinguishers manufactured prior to October 1984 shall be removed from service 
        at the next 6-year maintenance interval or the next hydrotest interval, whichever comes first. 
        4.4.2 Any fire extinguisher that can no longer be serviced in accordance with the manufacturer's maintenance manual is considered obsolete 
        and shall be removed from service. </pre
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'FE_3_Code_NFPA2007',
  data() {
    return {
      items: [
        {
          Extinguisher_Type: "Stored-pressure loaded-stream and antifreeze ",
          Internal_Examination_Interval_years: "1",
        },
        {
          Extinguisher_Type:
            "Pump tank water and pump tank calcium chloride based ",
          Internal_Examination_Interval_years: "1*",
        },
        {
          Extinguisher_Type:
            "Dry chemical, cartridge- and cylinder-operated, with mild steel shells ",
          Internal_Examination_Interval_years: "1*",
        },
        {
          Extinguisher_Type:
            "Dry powder, cartridge- and cylinder-operated, with mild steel shells ",
          Internal_Examination_Interval_years: "1",
        },
        {
          Extinguisher_Type: "Wetting agent ",
          Internal_Examination_Interval_years: "1",
        },
        {
          Extinguisher_Type: "Stored-pressure water",
          Internal_Examination_Interval_years: "5",
        },
        {
          Extinguisher_Type: "AFFF (aqueous film-forming foam)",
          Internal_Examination_Interval_years: "†",
        },
        {
          Extinguisher_Type: "FFFP (film-forming fluoroprotein foam)",
          Internal_Examination_Interval_years: "†",
        },
        {
          Extinguisher_Type:
            "Stored-pressure dry chemical, with stainless steel shells",
          Internal_Examination_Interval_years: "5",
        },
        {
          Extinguisher_Type: "Carbon dioxide",
          Internal_Examination_Interval_years: "5",
        },
        {
          Extinguisher_Type: "Wet chemical",
          Internal_Examination_Interval_years: "5",
        },
        {
          Extinguisher_Type:
            "Dry chemical stored-pressure, with mild steel shells, brazed brass shells, and aluminum shells",
          Internal_Examination_Interval_years: "6",
        },
        {
          Extinguisher_Type: "Halogenated agents",
          Internal_Examination_Interval_years: "6",
        },
        {
          Extinguisher_Type:
            "Dry powder, stored-pressure, with mild steel shells",
          Internal_Examination_Interval_years: "6",
        },
      ],
      items2: [
        {
          Extinguisher_Type: "Stored-pressure water, water mist, loaded stream, and/or antifreeze ",
          Test_Interval_years: "5",
        },
        {
          Extinguisher_Type: "Wetting agent ",
          Test_Interval_years: "5",
        },
        {
          Extinguisher_Type: "AFFF (aqueous film-forming foam)",
          Test_Interval_years: "5",
        },
        {
          Extinguisher_Type: "FFFP (film-forming fluoroprotein foam)",
          Test_Interval_years: "5",
        },
        {
          Extinguisher_Type: "Dry chemical with stainless steel shells",
          Test_Interval_years: "5",
        },
        {
          Extinguisher_Type: "Carbon dioxide",
          Test_Interval_years: "5",
        },
        {
          Extinguisher_Type: "Wet chemical",
          Test_Interval_years: "5",
        },
        {
          Extinguisher_Type: "Dry chemical, stored-pressure, with mild steel shells, brazed brass shells, or aluminum shells ",
          Test_Interval_years: "12",
        },
        {
          Extinguisher_Type: "Dry chemical, cartridge- or cylinder-operated, with mild steel shells ",
          Test_Interval_years: "12",
        },
        {
          Extinguisher_Type: "Halogenated agents ",
          Test_Interval_years: "12",
        },
        {
          Extinguisher_Type: "Dry powder, stored-pressure, cartridge- or cylinder-operated, with mild steel shells ",
          Test_Interval_years: "12",
        },
      ],
    };
  },
};
</script>

<style>
table,
th,
td {
  border: 1px solid black;
}
</style>
